export const DND_ITEM_TYPES = {
  GRAPHIC: 'graphic',
  PLAYLIST: 'playlist',
} as const;

export type DndItemType = (typeof DND_ITEM_TYPES)[keyof typeof DND_ITEM_TYPES];
